import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-443e38f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = { class: "card card-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "profile-img",
  src: "//ssl.gstatic.com/accounts/ui/avatar_2x.png",
  class: "profile-img-card"
}, null, -1))
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_7 = {
  class: "form-group",
  align: "right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_q_form, {
        onSubmit: _ctx.handleLogin,
        class: "q-gutter-md"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_input, {
            filled: "",
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
            label: _ctx.t('login.username'),
            hint: _ctx.t('login.enterlogin'),
            "lazy-rules": "",
            rules: [val => val && val.length > 0 || _ctx.t('login.loginisrequired')]
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "person" })
            ]),
            _: 1
          }, 8, ["modelValue", "label", "hint", "rules"]),
          _createVNode(_component_q_input, {
            filled: "",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            label: _ctx.t('login.password'),
            hint: _ctx.t('login.enterpassword'),
            type: _ctx.passwordFieldType,
            "lazy-rules": "",
            rules: [ val => val && val.length > 0 || _ctx.t('login.passwordrequired')]
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "lock" })
            ]),
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: _ctx.visibilityIcon,
                onClick: _ctx.switchVisibility,
                class: "cursor-pointer"
              }, null, 8, ["name", "onClick"])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "hint", "type", "rules"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_btn, {
              label: _ctx.t('maintoolbar.login'),
              class: "full-width",
              size: "lg",
              type: "submit",
              color: "primary",
              loading: _ctx.loading,
              disable: _ctx.loading
            }, null, 8, ["label", "loading", "disable"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_q_btn, {
              flat: "",
              color: "primary",
              onClick: _ctx.resetPassword,
              label: _ctx.t('login.forgottenyourpassword'),
              size: "sm",
              align: "right",
              disable: _ctx.loading
            }, null, 8, ["onClick", "label", "disable"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}